module.exports = __webpack_public_path__ + "static/img/logo.4adff6e3.svg";